// Our team's Amigo log (D8). Wording from the Amigo design's copy sheet (Amigo log, Amigo log couldn't do, Amigo log no
// results, Row status); FoodAmigos only, so always Amigo, never the assistant.
export default {
  title: 'Amigo-log',
  intro:
    'Hver anmodning, Amigo har håndteret: hvad der blev spurgt om, hvor, hvem der spurgte, og hvem der godkendte. Kun FoodAmigos kan se denne side.',
  // The tab list's name for screen readers.
  tabs_label: 'Amigo-log',
  tabs: {
    requests: 'Anmodninger',
    gaps: 'Kunne ikke gøres',
  },
  filters: {
    restaurant: 'Restaurant',
    all_restaurants: 'Alle restauranter',
    brand: '{{name}} · Brand',
    restaurant_unknown: 'Restaurant {{id}}',
    searching: 'Leder efter restauranter…',
    no_restaurant: 'Ingen restaurant ved navn “{{query}}”',
    period: 'Periode',
    start_date: 'Startdato',
    end_date: 'Slutdato',
    refresh: 'Opdater',
    gap: 'Spurgt om: {{request}}',
    change_set: 'Anmodningen bag én ændring',
    remove: 'Fjern filteret: {{label}}',
    clear: 'Ryd filtre',
  },
  columns: {
    steps: 'Trin',
    when: 'Hvornår',
    request: 'Anmodning',
    restaurant: 'Restaurant',
    asked_by: 'Spurgt af',
    result: 'Resultat',
  },
  show_steps: 'Vis trinene for: {{request}}',
  approved_by: 'Godkendt af {{name}}',
  nothing_approved: 'Intet godkendt',
  results: {
    applied: '{{applied}} udført',
    applied_skipped: '{{applied}} udført · {{skipped}} sprunget over',
    partial: '{{applied}} af {{total}} udført',
    imported: 'Importeret',
    importing: 'Importerer',
    waiting: 'Venter på godkendelse',
    rejected: 'Afvist',
    undone: 'Fortrudt',
    partly_undone: '{{undone}} af {{total}} fortrudt',
    expired: 'Udløbet',
    replaced: 'Erstattet',
    failed: 'Mislykkedes',
    answered: 'Besvaret',
    not_yet: 'Kunne ikke endnu',
    off_limits: 'Uden for rammerne',
    not_allowed: 'Ikke tilladt',
    switched_off: 'Slukket',
    guard: 'Stoppet af en sikkerhedskontrol',
    not_found: 'Ikke fundet',
  },
  steps: {
    asked: '{{name}} spurgte',
    asked_anonymous: 'Spurgt',
    approved: 'Godkendt af {{name}}',
    approved_alone: 'Godkendt',
    applied_one: '{{count}} ændring udført',
    applied_other: '{{count}} ændringer udført',
    failed_one: '{{count}} ikke udført',
    failed_other: '{{count}} ikke udført',
    rejected: 'Afvist',
    undone: 'Fortrudt',
    undone_by: 'Fortrudt, godkendt af {{name}}',
    skipped_one: '{{count}} sprunget over',
    skipped_other: '{{count}} sprunget over',
    skipped_state: 'Sprunget over',
    more_one: 'og {{count}} mere',
    more_other: 'og {{count}} mere',
    changes_one: '{{count}} ændring',
    changes_other: '{{count}} ændringer',
    other: 'Tjekker noget',
  },
  // The line over a request's steps (QA49): how many, how many shop refused, how many failed.
  summary: {
    steps_one: '{{count}} trin',
    steps_other: '{{count}} trin',
    refused_one: '{{count}} afvist',
    refused_other: '{{count}} afvist',
    failed_one: '{{count}} mislykkedes',
    failed_other: '{{count}} mislykkedes',
  },
  // A request that changed nothing says what came of it, under Result (design: Log · steps open).
  outcomes: {
    title: 'Resultat',
    answered: 'Et svar: intet ændret.',
    waiting: 'Afventer godkendelse. Intet er ændret endnu.',
    rejected: 'Afvist: intet ændret.',
    expired: 'Udløbet uden godkendelse: intet ændret.',
    replaced: 'Erstattet af et nyere kort: intet ændret her.',
    undone: 'Fortrudt: ændringerne er rullet tilbage.',
    partly_undone: 'Delvist fortrudt: {{undone}} af {{total}} ændringer blev rullet tilbage.',
    failed: 'Mislykkedes: intet ændret.',
    not_yet: 'Kunne ikke gøres endnu: intet ændret. Tæller med i Kunne ikke gøre.',
    off_limits: 'Uden for rammerne: intet ændret.',
    not_allowed: 'Ikke tilladt for denne persons rolle: intet ændret.',
    switched_off: 'Slået fra her: intet ændret.',
    guard: 'Stoppet af en sikkerhedskontrol: intet ændret.',
    not_found: 'Ikke fundet: intet ændret.',
    importing: 'Importerer. Hver ret havner i Menu → Redigeringshistorik.',
    imported: 'Importeret. Hver ret er i Menu → Redigeringshistorik.',
  },
  changes: {
    // With where they were made: "3 changes · Hilltop Burger · Ehrenfeld".
    where: '{{changes}} · {{where}}',
    title_one: '{{count}} ændring',
    title_other: '{{count}} ændringer',
    show_all: 'Vis alle {{count}} ændringer',
    show_fewer: 'Vis færre',
    from: 'fra',
    to: 'til',
    removed: 'Fjernet',
  },
  row_states: {
    skipped: 'Sprunget over',
    failed: 'Ikke udført',
    stale: 'Ændret i mellemtiden',
    kept: 'Ladt uændret',
  },
  menu_history: 'Åbn Menu → Redigeringshistorik',
  // Opens the request's chat in the Amigo panel, on its restaurant (read only when someone else started it).
  open_chat: 'Åbn chatten',
  // Both links first switch the dashboard to the request's restaurant; this says that didn't work.
  switch_failed: 'Restauranten kunne ikke åbnes. Prøv igen.',
  pagination: {
    label: 'Sider',
    summary: '{{from}}–{{to}} af {{total}} anmodninger',
    previous: 'Forrige side',
    next: 'Næste side',
  },
  empty: {
    title: 'Ingen anmodninger for {{restaurant}} i denne periode',
    text: 'Amigo har ikke håndteret noget der mellem {{from}} og {{to}}.',
    title_any_day: 'Ingen anmodninger for {{restaurant}} endnu',
    text_any_day: 'Amigo har ikke håndteret noget der endnu.',
    title_everywhere: 'Ingen anmodninger i denne periode',
    text_everywhere: 'Amigo har ikke håndteret noget mellem {{from}} og {{to}}.',
    title_nothing: 'Ingen anmodninger endnu',
    text_nothing: 'Amigo har ikke håndteret noget endnu.',
  },
  loading: 'Indlæser…',
  error: {
    title: 'Loggen kunne ikke indlæses',
    text: 'Prøv igen om et øjeblik.',
    retry: 'Prøv igen',
  },
  gaps: {
    intro:
      'Hvad Amigo ikke kunne endnu, grupperet efter hvad der blev spurgt om, mest spurgt først. Anmodninger uden for rammerne og anmodninger, en rolle ikke har lov til, vises ikke her.',
    columns: {
      area: 'Område',
      request: 'Hvad folk spurgte om',
      count: 'Spurgt',
      last_at: 'Senest spurgt',
      requests: 'Anmodninger',
    },
    count: '{{count}}×',
    see_requests_one: 'Se {{count}} anmodning',
    see_requests_other: 'Se {{count}} anmodninger',
    today: 'I dag kl. {{time}}',
    yesterday: 'I går kl. {{time}}',
    empty_title: 'Ingen anmodninger, Amigo ikke kunne udføre',
    empty_text: 'Alt, hvad folk har bedt om, kunne Amigo udføre.',
  },
  areas: {
    menu: 'Menu',
    hours: 'Åbningstider',
    order_settings: 'Ordreindstillinger',
    my_info: 'Mine oplysninger',
    marketing: 'Marketing',
    gift_cards: 'Gavekort',
    reports: 'Rapporter',
    website: 'Hjemmeside',
    integrations: 'Integrationer',
    delivery: 'Levering',
    payments: 'Betalinger',
    team: 'Team',
    billing: 'Fakturering',
    settings: 'Indstillinger',
    other: 'Andet',
  },
};
